import { motion } from "framer-motion";
import { WHY_SIPL } from "@/lib/sipl-content";

const TONE = {
  primary: "bg-sipl-primary text-white border-sipl-primary",
  secondary: "bg-sipl-secondary text-white border-sipl-secondary",
  accent: "bg-sipl-accent text-white border-sipl-accent",
  neutral: "bg-white text-sipl-primary border-sipl-line",
};

export default function WhyChoose() {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="section-y bg-white"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mb-14 items-end">
          <div>
            <div className="text-sm uppercase tracking-[0.22em] text-sipl-secondary mb-4 dash-accent">
              Why Choose SIPL
            </div>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-sipl-primary font-semibold tracking-tight leading-[1.08]">
              Engineering rigour. Government-grade trust.
            </h2>
          </div>
          <p className="text-sipl-fg/70">
            We bring the discipline of public-sector engineering with the speed
            and accountability of private execution — the right partner for
            ESG-focused infrastructure mandates.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-8 lg:grid-cols-12 gap-5 lg:gap-6">
          {WHY_SIPL.map((f, idx) => {
            const Icon = f.icon;
            return (
              <motion.div
                key={f.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-80px" }}
                transition={{ duration: 0.55, delay: idx * 0.07 }}
                data-testid={`why-card-${idx}`}
                className={`md:col-span-4 ${f.span} rounded-lg border p-7 lg:p-8 flex flex-col gap-4 min-h-[200px] ${TONE[f.tone]}`}
              >
                <div
                  className={`w-11 h-11 rounded-md flex items-center justify-center ${
                    f.tone === "neutral"
                      ? "bg-sipl-primary/10 text-sipl-primary"
                      : "bg-white/15 text-white"
                  }`}
                >
                  <Icon className="w-5 h-5" />
                </div>
                <h3 className="font-heading text-xl font-medium leading-tight">
                  {f.title}
                </h3>
                <p
                  className={`text-sm leading-relaxed ${
                    f.tone === "neutral" ? "text-sipl-fg/70" : "text-white/85"
                  }`}
                >
                  {f.desc}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
